module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/img_mob-6964bb8601833ef28e020f550d240f7c.png";